import React, { Component } from 'react';
import { AUARequest } from '../AUA';
import { Col, Container, Row } from 'reactstrap';
import { R } from '../routes';

import { T } from '../traks';
import Butt from '../c/Butt.js';
import { OpenForgotPassword } from '../c/SignupLogin';

class PasswordReset extends Component {
	constructor(props) {
		super(props);
		this.state = {password: "", password_again: "", error: false, ok: null};
	}

	do_the_post(password, dryrun, callback) {
		const args = R.get_args();
		const token = args.token;
		const email = args.email;
		AUARequest.set_password_with_token(token, email, password, dryrun, callback);
	}

	componentDidMount() {
		this.do_the_post("", true, (err) => {
			this.setState({ok: !err});
		});
	}

	render() {
		if (this.state.ok === null) {
			return null;
		} else if (this.state.ok === false) {
			const click = () => OpenForgotPassword();
			return (
				<Container>
					<Row><Col>
						<div className="ad_profile_gray pt-5">
							<h2 className="font-light"><T>The password reset email has expired</T></h2>
						</div>
					</Col></Row>
					<Row><Col>
						<T>This can happen if you
						waited too long after sending
						the email or if you have
						already used it to reset your
						password.</T>
					</Col></Row>
					<Row className="py-2"><Col>
						<Butt onClick={click}><T>Click here to try again</T></Butt>
					</Col></Row>
				</Container>
			);
		}

		const change = (e) => {
			this.setState({[e.target.name]: e.target.value});
		};

		const submit = (e) => {
			e.preventDefault();
			const { password, password_again} = this.state;
			if (password === "") {
				this.setState({error: "empty_password"});
			} else if (password !== password_again) {
				this.setState({error: "password_mismatch"});
			} else {
				this.do_the_post(this.state.password, false, (err) => {
					R.go("/")
				});
			}
		};

		const password_value = this.state.password;
		const password_again_value = this.state.password_again;

		const input_classname = (more, has_error) => {
			var c = "form-control ad_profile_gray";
			if (more) c += more;
			if (has_error) c += " ad_pref_input_error";
			return c;
		};

		var error_element = null;
		var password_error = false;
		var password_again_error = false;
		if (this.state.error === "empty_password") {
			password_error = true;
			error_element = <span>You must type in a new password</span>;
		} else if (this.state.error === "password_mismatch") {
			password_error = true;
			password_again_error = true;
			error_element = <span>Passwords do not match</span>;
		}

		return (
			<form onSubmit={submit}>
				<Container>
					<div className="ad_profile_gray pt-5">
						<h2 className="font-light"><T>Reset your password</T></h2>
						<hr className="ad_profile_gray my-4"/>
					</div>
					<Row className="pb-4">
						<Col xs="12" md="3">
						<div className="w-100">
							<div className="mb-2"><T>New password</T></div>
							<input
								className={input_classname("", password_error)}
								placeholder="Password"
								type="password"
								name="password"
								value={password_value}
								onChange={change}
							/>
						</div>
						</Col>
					</Row>
					<Row className="pb-4">
						<Col xs="12" md="3">
						<div className="w-100">
							<div className="mb-2"><T>New password again</T></div>
							<input
								className={input_classname("", password_again_error)}
								placeholder="Password again"
								type="password"
								name="password_again"
								value={password_again_value}
								onChange={change}
							/>
						</div>
						</Col>
					</Row>
					{error_element && <Row><div className="errors">{error_element}</div></Row>}
					<Row className="pb-4">
						<Col xs="12" md="3">
							<Butt type="submit" className="xyzzy_button py-2 px-3"><T>Change password</T></Butt>
						</Col>
					</Row>
					<div className="ad_pb-10"/>
				</Container>
			</form>
		);
	}
}

export default PasswordReset;



// WEBPACK FOOTER //
// ./src/p/PasswordReset.js